if (!customElements.get('main-video-element')) {
  class MainVideoElement extends HTMLElement {
    constructor() {
      super();
      this.selector = {
        video: 'video',
        img: 'img'
      };
      this.init();
    }

    init() {
      this.video = this.querySelector(this.selector.video);
      this.image = this.querySelector(this.selector.img);
      if (this.video) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
                this.playVideo();
              } else {
                this.pauseVideo();
              }
            });
          },
          {
            threshold: [0.2]
          }
        );

        this.observer.observe(this);

        window.addEventListener('load', () => {
          this.video.load();
          this.video.addEventListener('canplaythrough', () => {
            console.log("Video can play through");
          });
        });
      }
    }

    playVideo() {
      if (this.video) {
        this.video.play();
        this.video.classList.remove('hidden');
        if (this.image) {
          this.image.classList.add('hidden');
        }
      }
    }

    pauseVideo() {
      if (this.video) {
        this.video.pause();
      }
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.unobserve(this);
      }
    }
  }

  customElements.define('main-video-element', MainVideoElement);
}
